import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const CargrListingDialog = ({ car, onClose, onSaved }) => {
  const [value, setValue] = useState(car?.cargr_listing_id || "");
  const [saving, setSaving] = useState(false);
  if (!car) return null;

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.patch(`/cars/${car.id}/cargr-listing`, { listing: value });
      toast.success(r.data.cargr_listing_id ? "Αποθηκεύτηκε ο αριθμός αγγελίας" : "Ο αριθμός αγγελίας αφαιρέθηκε");
      onSaved(car.id, r.data.cargr_listing_id);
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Αποτυχία αποθήκευσης");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="cargr-listing-dialog">
        <DialogHeader>
          <DialogTitle>Αγγελία car.gr — {car.brand} {car.model}</DialogTitle>
          <DialogDescription>
            Επικολλήστε το link της αγγελίας από το car.gr ή σκέτο τον αριθμό της.
          </DialogDescription>
        </DialogHeader>
        <input
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && !saving && save()}
          placeholder="π.χ. https://www.car.gr/cars/view/53024901/ ή 53024901"
          className="w-full border border-black/15 px-3 py-2 text-sm font-mono focus:outline-none focus:border-[#0055FF]"
          data-testid="cargr-listing-input"
        />
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-1.5 text-xs border border-black/10 hover:bg-black/5" data-testid="cargr-listing-cancel">
            Άκυρο
          </button>
          <button onClick={save} disabled={saving} className="px-4 py-1.5 text-xs bg-[#0055FF] text-white hover:bg-[#0044CC] disabled:opacity-50" data-testid="cargr-listing-save">
            {saving ? "Αποθήκευση..." : "Αποθήκευση"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
